module.exports = __webpack_public_path__ + "img/collectionFrequencyFail.3dded30f.png";